import {sqftPost} from "./sqftApi";
import sqftConfig from "../components/canvas/store/sqftConfig";

const HARDCODED_DOMAIN = sqftConfig.threeD.useStagingDomain ? "https://quotekandb.com" : null; //

export default class SqftJsonApi {
  static postCabinetSet(data, options = {}) {
    return sqftPost("/api/AR/Composer", data, {...options, domain: HARDCODED_DOMAIN});
  }

  static getCountertops(data, options = {}) {
    return sqftPost("/api/AR/Composer/countertop", data,{...options, domain: HARDCODED_DOMAIN});
  }

  static getResizedCabinet(data, options = {}) {
    return sqftPost("/api/AR/Composer/cabinet_resize", data,{...options, domain: HARDCODED_DOMAIN});
  }

  static getResizedCornerCabinet(data, options = {}) {
    return sqftPost("/api/AR/Composer/corner_cabinet_resize", data,{...options, domain: HARDCODED_DOMAIN});
  }

  static getWall(data, options = {}) {
    return sqftPost("/api/AR/Composer/wall", data,{...options, domain: HARDCODED_DOMAIN});
  }
}
